@if (processView$ | async; as processView) {
	<article class="module widget">
		@if (processView.allowedOperations.CREATE_FEEDBACK) {
			@if (state === "minified" || state === "open" || state === "inProgress") {
				<div class="form">
					<div [formGroup]="form" id="edit-attributes-container">
						@if (state !== "minified") {
							<div class="input-container right">
								<button class="button sm cancel" translate="cancel" (click)="cancel()"></button>
								<button
									class="button sm save"
									(click)="save(processView)"
									[disabled]="!isSubmitAllowed('summary') || state === 'inProgress'"
								>
									@if (state !== "inProgress") {
										<span translate="save"></span>
									}
									@if (state === "inProgress") {
										<stages-spin size="sm"></stages-spin>
									}
								</button>
							</div>
						}
						<div class="input-container">
							<stages-input [form]="form" [input]="summaryInput"></stages-input>
							@if (state !== "minified") {
								@for (input of inputs; track input) {
									<div class="fullsize">
										<stages-input [form]="form" [input]="input"></stages-input>
									</div>
								}
							}
						</div>
						@if (state !== "minified") {
							<div class="input-container right">
								<button class="button sm cancel" translate="cancel" (click)="cancel()"></button>
								<button
									class="button sm save"
									(click)="save(processView)"
									[disabled]="!isSubmitAllowed('summary') || state === 'inProgress'"
								>
									@if (state !== "inProgress") {
										<span translate="save"></span>
									}
									@if (state === "inProgress") {
										<stages-spin size="sm"></stages-spin>
									}
								</button>
							</div>
						}
					</div>
				</div>
			}
			@if (state === "created") {
				<div class="form">
					<div class="form-group">
						<div class="input-container sm">
							<p>
								<span translate="process.feedback.created"></span>&nbsp;
								<a [href]="response.uri" target="_blank" rel="noopener noreferrer">{{ response.summary }}</a>
							</p>
						</div>
					</div>
					<div class="input-container right">
						<button class="button sm cancel" translate="close" (click)="cancel()"></button>
					</div>
				</div>
			}
			@if (state === "error") {
				<div class="form">
					<div class="form-group">
						<div class="input-container sm">
							<p class="title" translate="error.general.title"></p>
							<p class="error" translate="error.general.message"></p>
						</div>
					</div>
					<div class="input-container right">
						<button class="button sm back" translate="back" (click)="retry()"></button>
						<button class="button sm cancel" translate="cancel" (click)="cancel()"></button>
					</div>
				</div>
			}
		}
		@if (!processView.allowedOperations.CREATE_FEEDBACK) {
			<p class="empty" translate="none"></p>
		}
	</article>
}
